<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-06-14 15:41:15
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-09 15:58:27
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/App.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },

  mounted() {
    // this.handleListenerResize()
    // this.$nextTick(_ => {
    //   const realHeight = window.innerWidth > window.innerHeight ? window.innerWidth :
    //     window.innerHeight
    //   const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
    //   window.addEventListener('resize', () => {
    //     //键盘弹起与隐藏都会引起窗口的高度发生变化
    //     const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
    //     if (resizeHeight - 0 < originalHeight - 0) {
    //       //当软键盘弹起，在此处操作
    //       console.log('进入到软键盘弹起=========')
    //       this.setMetaHeight(realHeight)
    //     } else {
    //       //当软键盘收起，在此处操作
    //       console.log('进入到软键盘收起=========')
    //       this.setMetaHeight('100%')
    //     }
    //   })
    // })
  },

  methods: {

    // 设置meta高度 解决安卓浏览器软键盘弹起，占用窗口的面积问题
    setMetaHeight(height) {
      document.head.querySelector("meta[name='viewport']").setAttribute('id', 'viewportMeta')
      let metaEl = document.querySelector('#viewportMeta')
      let content = 'height=' + height + ',width=device-width,initial-scale=1.0,user-scalable=no'
      metaEl.setAttribute('name', 'viewport')
      metaEl.setAttribute('content', content)
      this.$forceUpdate()
    },

    handleListenerResize() {
      window.addEventListener('resize', function (e) {
        if (this.checkKeyboard()) { // 检测键盘是否弹出
          console.log("弹出")
          var inputElement = document.activeElement; // 获取当前激活的输入框
          if (inputElement) {
            inputElement.scrollIntoView(); // 滚动到视图中
          }
        }
      });
    },
    checkKeyboard() {
      // 根据页面的变化（如页面的高度）来判断键盘是否弹出
      return (window.innerHeight > document.documentElement.clientHeight);
    }
  },
};
</script>
<style lang="less">
@import './assets/common.css';
@import "./style/common.css";

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  min-height: 100vh;
  width: 100vw;
  // background-color: #fff;
}

* {
  margin: 0;
  padding: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
